var HAS_EVENT = true; //トップの#main_bannerに固定の静的な要素を出すためのフラグ
let loadedData = {
	topics: [],
	topicsSpecial: [],
	sorted: []
}
var load = {
	beforeSongTime: "",
	beforeChannelTime: "",
	topXML: function(){
		load.nowonair();
		load.nowplaying();
		setInterval(function(){
			//marquee.reset();
			load.nowonair();
			load.nowplaying();
		}, 60000);
		//load.topics();
		load.podCast();
		load.minibnr();
		load.news();
		load.loadPressRelease();
	},
	nowonair: function(){
		let onAirURL = "/epg/program/now_on_air.xml";
		//let onAirURL = "/epg/program/now_on_air_200329.xml";
		let params = {};
		let onairHTML = '';

		let now 	= new Date();
		
		//console.log(current);
		load.getXML(onAirURL, params).done(function(data){
			let afterCount = 0;
			let isFuture = false;
			//console.log(data);
			//let currentD = new Date(2020,4,4,10,43);
			//let currentD = new Date(2021, 0, 19, 4, 0);
			let currentD = new Date();
			let current = currentD.getTime(),
				_year 	= currentD.getFullYear(),
				_month 	= currentD.getMonth() + 1,
				_day 	= currentD.getDate(),
				_hour 	= currentD.getHours();
			//console.log(_month, _day, _hour)
			if(_hour >= 0 && _hour < 5){
				_day = _day-1;
			}
			//console.log(_month, _day, _hour)
			let hasItem = false;
			findCurrentItem(data);

			function findCurrentItem(data){
				$(data).find("item").each(function(i){
					let $this = $(this);
					let times = $(this).find("time").text();
					let timeAry = times.split("-");
					let s = timeAry[0];
					let ssplit = s.split(":");
					let e = timeAry[1];
					let esplit = e.split(":");
					//START
					let startNum = parseInt( ssplit[0] );

					if(startNum >= 24){
						var setnow = new Date(_year, _month-1, _day);
						setnow.setDate(setnow.getDate()+1);
						let n = parseInt( ssplit[0]) - 24;
						if(n === 0 || n <= 5){
							var start = setnow.getFullYear() + "/" + (setnow.getMonth()+1) + "/" + (setnow.getDate() ) + " " + ( '00' + n ).slice( -2 ) + ":" + esplit[1];
						}else{
							var start = setnow.getFullYear() + "/" + (setnow.getMonth()+1) + "/" + (setnow.getDate() -1 ) + " " + ( '00' + n ).slice( -2 ) + ":" + esplit[1];
						}
						var startDate = new Date(start).getTime();
					}else{
						var start 	= _year + "/" + _month + "/" + _day + " " + s;
						var startDate = new Date(start).getTime();
					}
					//END
					let endNum = parseInt( esplit[0] );
					
					if(endNum >= 24){
						var setnow = new Date(_year, _month-1, _day);
						setnow.setDate(setnow.getDate()+1);
						let n 		= parseInt( esplit[0] ) - 24;
						if(n === 0 || n <= 5){
							var end 	= setnow.getFullYear() + "/" + (setnow.getMonth() + 1) + "/" + (setnow.getDate() ) + " " + ( '00' + n ).slice( -2 ) + ":" + esplit[1];
						}else{
							var end 	= setnow.getFullYear() + "/" + (setnow.getMonth() + 1) + "/" + (setnow.getDate() -1 ) + " " + ( '00' + n ).slice( -2 ) + ":" + esplit[1];
						}
						
						//console.log(end)
						//var endDate = new Date(end).getTime();
					}else{
						var end = _year + "/" + _month + "/" + _day + " " + e;
					}
					/* 朝の5時が5:00と表記された場合はこちら
					else if(endNum === 5){
						var end 	= setnow.getFullYear() + "/" + (setnow.getMonth() + 1) + "/" + (setnow.getDate() ) + " " + ( '00' + 5 ).slice( -2 ) + ":" + esplit[1];
						//var endDate = new Date(end).getTime();
					}
					*/
					var endDate = new Date(end).getTime();
					//console.log(current, startDate, endDate)
					//console.log(start, end)
					let sss = "%c" + startDate;
					let eee = "%c" + endDate;
					//console.log(current, startDate, endDate)
					if(current >= startDate && current < endDate){
						let $this = $(this);
						hasItem = true;
						isFuture = true;
						let currentTime = $this.find("time").text();
						if(currentTime != load.beforeChannelTime){
							$("#block_now_on_air").addClass("change");
							setTimeout(function(){
								let title 		= $this.find("title").text().replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
								$("#now_on_air .img_onair figure").css({
									"background-image" :"url(" + $this.find("main_photo").text() + ")"
								});

								$("#now_on_air .ttl_onair p.time").html( currentTime );
								$("#now_on_air h4").html( $this.find("p_name").text() );
								let onairTxt = '<a href="https://www.j-wave.co.jp/today/">' + title + '</a>';
								// + title + title
								let time = title.length*250;
								if(time < 10000){
									time = 10000;
								}
								$(".marquee").attr("data-duration", time);

								$("#now_on_air .marquee p").html( onairTxt );
								$("#now_on_air a.link_channel_hp").attr("href", $this.find("link").text() );
								let navigators = $this.find("navigator").text();
								let nArry = navigators.split("/");
								let nHTML = '';
								for(var i = 0; i < nArry.length; i++){
									//nHTML += '<li>' + nArry[i].replace(" ", "") + '</li>'
									//console.log(nArry[i]);
									nHTML += '<li>' + nArry[i] + '</li>'
								}
								$("#now_on_air ul.navigator").html(nHTML);
								//console.log(title, nohtmltitle,  name, p_name);
								//console.log(sss, 'color: pink');
								//console.log(eee, 'color: green');
								marquee.init();
								load.beforeChannelTime = times;

								
								if(isSmallScreen){
									$("#now_on_air").removeClass("disable");
								}else{
									setTimeout(function(){
										$("#now_on_air").removeClass("disable");
									}, 300);
								}

								setTimeout(function(){
									common.scrl();
									//$("#now_on_air").removeClass("disable");
								},600);
							}, 600);
						}
					}else{
						//NEXT 2件
						if(isFuture){
							if(afterCount < 2){
								let $this = $(this);
								load.makeNextOnAir($this,afterCount);
							}
							afterCount++;
						}
					}
				});
				
				if(!hasItem){
					//console.log("一分引く")
					currentD.setMinutes(currentD.getMinutes() - 1);
					current = currentD.getTime();
					findCurrentItem(data);
				}
			}
		});
	},
	makeNextOnAir: function(data, i){
		let $this = data;
		let $blk = $("#block_next_onair .list_next").eq(i);
		$blk.find("p.time").html( $this.find("time").text() );
		$blk.find("h4").html( $this.find("p_name").text() );
		let navigators = $this.find("navigator").text();
		$blk.find("figure").css({
			"background-image" :"url(" + $this.find("main_photo").text() + ")"
		});
		$blk.find("a.link_channel_hp").attr("href", $this.find("link").text() );
		let nArry = navigators.split("/");
		let nHTML = '';
		for(var i = 0; i < nArry.length; i++){
			nHTML += '<li>' + nArry[i].replace(" ", "") + '</li>'
		}
		let title = $this.find("title").text().replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
		$blk.find("p.txt_lead").html(title);
		$blk.find("ul.navigator").html(nHTML);
	},
	nowplaying: function(){
		let onplayingURL = "/top/xml/now_on_air_song_v2.xml";
		let params = {};
		let $currentSong;
		load.getXML(onplayingURL, params).done(function(data){
			let $data = $(data);
			//console.log($data.find("now_on_air_song"));
			$data.find("now_on_air_song").each(function(i){
				//1つ目が今流れている曲
				if(i === 0){
					$currentSong = $(this);
				}
			});
			let info = $currentSong.find("data").attr("information");
			let infoArry = info.match(/「(.*)」\s*(.*)?\s([0-9]{1,2}:[0-9]{1,2})\s*$/);
			let clipID = $currentSong.find("data").attr("clip_id");
			//console.log(clipID)
			$("#playing_content a.btn_clip").attr("id", clipID);
			if(infoArry[3] != load.beforeSongTime){
				$("#block_playing").addClass("change");
				setTimeout(function(){
					$("#playing_content dt").html(infoArry[1]);
					$("#playing_content dd.artist_name").html("<span>" + infoArry[2] + "</span>");
					$("#playing_content dd.time").html(infoArry[infoArry.length-1]);
					$("#block_playing").removeClass("change");
				}, 600);
			}
			load.beforeSongTime = infoArry[3];
			$("#block_playing .playtime dd").html(infoArry[3]);
			common.activeClip();
			//$("#now_on_air").removeClass("disable");
		});
	},
	minibnr: function(){
		let miniBnrUrl = "/top/xml/minibanner.xml";
		let params = {};
		load.getXML(miniBnrUrl, params).done(function(data){
			let bnrHTML = '';
			$(data).find("data").each(function(i){
				let link 	= $(this).attr("link");
				let imgName = $(this).attr("file_name");
				let isBlank = $(this).attr("target");
				bnrHTML += '<li><a href="' + link + '" target="' + isBlank + '" data-id="' + i + '"><figure><img src="/top/img/minibanner/' + imgName + '" alt=""></figure></a></li>';
			});
			$(".bnr_col3 ul.slideshow_content").html(bnrHTML);
			setTimeout(function(){
				//load.top10();
			}, 200);
		});
	},
	news: function(){
		let newsURL = "/top/xml/jtop.xml";
		let params = {};
		load.getXML(newsURL, params).done(function(data){
			let newsHTML = '';
			$(data).find("item").each(function(i){
				//console.log( $(this) );
				let title 	= $(this).find("title").text();
				let link 	= $(this).find("link").text();
				let date 	= $(this).find("lastBuildDate").text();
				let img 	= $(this).find("enclosure").attr("url");
				newsHTML 	+= '<li><a href="' + link + '" title="' + title + '">'
							+	'<div class="img">'
							+	'<figure style="background-image: url(' + img + ')"></figure>'
							+	'</div>'
							+	'<div class="txt">'
							+	'<div class="txt_inner">'
							+	'<h4>' + title + '</h4>'
							+	'<p class="date">' + date + '</p>'
							+	'</div>'
							+	'</div></a></li>';
			});
			$(".list_news").html(newsHTML);
		});
	},
	top10: function(){
		let musicApis = [
			{ "id": "top10", "url": "/blog/tokio_system/index.xml", "category": "TOP10" },
			{ "id": "sonar", "url": "/top/xml/sonar.xml", "category": "recomennd" }
		]
		//console.log("top10");
		musicApis.forEach( (m, index) => {
			let params = {};
			let top10arry 	= [];
			let listHTML 	= '';
			let $target = document.querySelector(`[data-music="${m.id}"]`);
			load.getXML(m.url, params).done(function(data){
				let $thisData = $(data).find("channel");
				let count = 0;
				let $items = $thisData.find("item");
				
				if(index === 1){
					let update 	= $thisData.find("update").text();
					//console.log(update);
					$target.parentNode.parentNode.querySelector(".ttl_update span.date").innerHTML = update;
				}
				//console.log(index, $thisData);
				$thisData.find("item").each(function(i){
					//日付取得
					let d 			= $(this).find("description").text();
					let thisData 	= $.parseXML("<xml>" + d + "</xml>");
					let t 			= $(thisData).find("time").text();
					if(t != "undefined" && t != "" && index === 0){
						$target.parentNode.parentNode.querySelector(".ttl_update span.date").innerHTML = t;
					}
				
					/*
					if(index === 1){
						console.log($(thisData));
					}
					*/
					if($(this).find("category").text() === m.category){
						if(count <= 9){
							let artistName 	= $(thisData).find("artist").text(),
								songName 	= $(thisData).find("song").text(),
								buyID		= $(thisData).find("BUYCD").text(),
								timefree 	= $(thisData).find("TIMEFREE").text(),
								clipID 		= $(thisData).find("clip_id").text(),
								buyCDURL 	= "",
								timeFreeURL = "";
							let subscription = "";
							if( index === 0){
								subscription = $(thisData).find("subscription").text();
								console.log(subscription);
							}else{
								subscription = $(this).find("subscription").text();
							}
							//console.log(index, $(thisData), clipID);
							let btnSubscription = "";
							//console.log($(thisData))
							if(buyID != ""){
								buyCDURL = '<li class="btn_buycd"><a href="http://www.neowing.co.jp/JWAVE/detailview.html?KEY=' + buyID + '" title="BUY NOW" target="_blank" rel="noopener"><span>BUY NOW</span></a></li>';
							}
							if(timefree != ""){
								timeFreeURL = '<li class="btn_timefree"><a href="' + timefree + '" title="TIME FREE" target="_blank" rel="noopener"><span>TIME FREE</span></a></li>'
							}
							if( subscription != "" ){
								btnSubscription = `<li class="btn_subscription"><a href="${subscription}" title="サブスクで聴く"><span>サブスクで聴く</span></a></li>`;
							}
							let btnClip = "";
							if( clipID != "" ){
								btnClip = '<li class="btn_clip"><a id="' + clipID + '" class="btn_clip" href="javascript:void(0);" title="CLIP TO MY J-WAVE"><span>CLIP TO <br />MY J-WAVE</span></a></li>'
							}
							
							//console.log(artistName, buyID);
							let blockNum = '<p class="num">' + ( '00' + (count+1) ).slice( -2 ) + '</p>';
							let img = "";
							if(m.id === "sonar"){
								blockNum = "";
								timeFreeURL = "";
								img = $(this).find("pict").text();
							}else{
								img = `/blog/tokio_system/images/photo${(count+1)}.jpg`;
							}
							listHTML 	+= '<li class="list_rank">'
										+ '<div class="col2">'
										+ '<figure style="background-image: url(' + img + ')"></figure>'
										+ '<div class="col_r">'
										+ blockNum
										+ '<ul>'
										+ btnClip
										+ timeFreeURL
										//+ buyCDURL
										+ btnSubscription
										+ '</ul>'
										+ '</div>'
										+ '</div>'
										+ '<div class="info">'
										+ '<dl>'
										+ '<dt>' + songName + '</dt>'
										+ '<dd>' + artistName + '</dd>'
										+ '</dl>'
										+ '</div>'
										+ ' </li>';
						}
						count++;
					}
				});
				$target.innerHTML = listHTML;
				//$("#thisweektop10 .list_ranks").html(top10HTML);
				if(index === musicApis.length - 1){
					console.log("%cMusic Data Added: ","color:white; background-color: #138D75 ; padding:2px; border-radius:4px;");
					setTimeout(function(){
						top10Slide.init();
						common.activeClip();
						common.navforIndex();
						common.scrl();
					},200);
				}
			});
		});
	
	},
	topics: function(){
		loadedData.topics 			= [];
		loadedData.topicsSpecial 	= [];
		loadedData.sorted 			= [];
		let topicsURL = "/top/xml/topics_v2.xml";
		let params = {};
		let topicsHTML 	= '';
		let latestHTML 	= '';
		let smallHTML 	= '';
		let bnrHTML 	= "";
		let bnrCount 	= 0;
		let topicsData = [];
		const topicsObj = {
			"text"			: "",
			"content"		: "",
			"category" 		: "",
			"photo_url"		: "",
			"link"			: "",
			"target"		: "",
			"limit" 		: "",
			"flag" 			: ""
		}
		load.getXML(topicsURL, params).done( function(data){
			let d = $(data).find("topics");
			
			let countB 	= 0;
			let count 	= 0;
			let hasSpecial = false;
			let specialHTML = '';
			let specialData = "";

			var bigs = [];		//bigを格納しておく配列
			var bigsNum = [];	//bigの数だけカウントアップで数字が入る_
			var thisBigNum = 0; // bigのflagの中からランダムに選ばれた数字
			
			d.find("item").each(function(i){
				let $this = this;
				let _t 		= object(topicsObj);
				_t.text 	= $this.getAttribute("text");
				_t.content 	= $this.textContent;
				_t.category = $this.getAttribute("category");
				_t.photo_url = $this.getAttribute("photo_url");
				_t.link 	= $this.getAttribute("link");
				_t.target	= $this.getAttribute("target");
				_t.limit 	= $this.getAttribute("limit");
				_t.flag 	= $this.getAttribute("flag");
				loadedData.topics.push(_t);
				let cat = _t.category.toLowerCase();
				cat = cat.includes(" ") ? cat.replace(" ", "_") : cat;
				if( !loadedData.sorted[cat] ){
					loadedData.sorted[cat] = [];
				}
				loadedData.sorted[cat].push(_t);
				//let flag = $(this).attr("flag");
				if(_t.flag === "special"){
					specialData = $this;
					hasSpecial = true;
					return false
				}
			});
			console.log("%cTopics Data: ","color:white; background-color: #138D75 ; padding:2px; border-radius:4px;", loadedData.topics);
			console.log("%cTopics Data Sorted: ","color:white; background-color: #138D75 ; padding:2px; border-radius:4px;", loadedData.sorted);
			
			
			if(!hasSpecial){
				let count = 0;
				loadedData.topics.forEach( (d, index) => {
					if(d.flag === "big"){
						loadedData.topicsSpecial.push(d);
						bigsNum.push(index);
						count++;
					}
				});
				/*
				d.find("item").each(function(i){
					let thisData = this;
					let flag = $(this).attr("flag");
					if(flag === "big"){
						bigs.push(thisData);
						bigsNum.push(i);
						count++;
					}
				});
				*/
				var thisNum = Math.floor(Math.random()*bigsNum.length);
				specialData = loadedData.topicsSpecial[thisNum];
			}
			//console.log(specialData);
			specialHTML 	= '<a href="' + specialData.link + '" title="' + specialData.text + '" data-category="' + specialData.category + '"><div class="img_banner">'
							+ '<figure style="background-image: url(' + specialData.photo_url + ')"></figure>'
							+ '</div>'
							+ '<div class="txt_banner">'
							+ '<div class="txt_inner">'
							+ '<div class="ttl">'
							+ '<h3>' + specialData.text + '</h3>'
							+ '</div>'
							+ '<div class="txt">'
							+ '<p>' + specialData.content + '</p>'
							+ '</div>'
							+ '</div>'
							+ '</div></a>';
			$("#main .col_r #main_banner").html(specialHTML);

			//
			let countLatest = 0;
			d.find("item").each(function(i){
				let thisData = this;
				let flag 	= $(this).attr("flag");
				let ttl 	= $(this).attr("text");
				let img 	= $(this).attr("photo_url");
				let text 	= $(this).text();
				let link 	= $(this).attr("link");
				let cat 	= $(this).attr("category");

				if(countB < 3){
					if(flag === "topics"){
						topicsHTML 	+= '<li><a href="' + link + '" title="' + ttl + '">'
									+	'<div class="img">'
									+	'<figure style="background-image: url(' + img + ')"></figure>'
									+	'</div>'
									+	'<div class="txt">'
									+	'<div class="txt_inner">'
									+	'<div class="ttl_topics">'
									+	'<h4>' + ttl + '</h4>'
									//+	'<p class="category">' + cat + '</p>'
									+	'</div>'
									//+	'<p>' + text + '</p>'
									+	'</div>'
									+	'</div></a></li>';
						countB++;
					}
				}
				
				if(flag === "big"){
					//console.log(hasSpecial, countLatest)
					if(!hasSpecial && countLatest === thisNum){
						countLatest++;
					}else{
						latestHTML 	+= '<li><a href="' + link + '" title="' + ttl + '">'
								+	'<div class="img"><figure style="background-image: url(' + img + ')"></figure></div>'
								+	'<div class="txt_latest">'
								+	'<div class="txt_latest_inner">'
								+	'<div class="ttl">'
								+	'<h4>' + ttl + '</h4>'
								+	'<p class="category">' + cat + '</p>'
								+	'</div>'
								+	'<p>' + text + '</p>'
								+	'</div>'
								+	'</div></a></li>';
						countLatest++;
					}
					
				}
				
				if(flag != "big"){
					if(flag === "text"){
						//flag === "topics"
						if(count > 6){
							var $li = '<li class="sp_hide hide">';
						}else{
							var $li = '<li>';
						}
						smallHTML 	+= 	$li + '<a href="' + link + '" title="' + ttl + '">'
									+	'<div class="col2">'
									+	'<div class="img">'
									+	'<figure style="background-image: url(' + img + ')"></figure>'
									+	'</div>'
									+	'<div class="txt">'
									+	'<div class="txt_inner">'
									+	'<p class="cat">' + cat + '</p>'
									//+	'<dl>'
									//+	'<dt>2020.01.01</dt>'
									//+	'<dd>' + cat + '</dd>'
									//+	'</dl>'
									+	'<h4>' + ttl + '</h4>'
									+	'</div>'
									+	'</div>'
									+	'</div></a></li>';
						count++;
					}
				}
			});
			$("#slide_latest ul.slideshow_content").html(latestHTML);
			$("#topics .list_col3 .list_topics").html(topicsHTML);
			$("#topics .list_col2 .list_topics").html(smallHTML);
			//$(".bnr_col3 .slide_bnr ul").html(bnrHTML);
			//THE LATEST

			//topicsのスライドショー
			
			setTimeout(function(){
				topicsSlide.init();
				spSlideshow.init();
				load.top10();
			}, 200);
		});
	},
	loadPressRelease: function(){
		let url = "/js/press_release.json";
		let param = {};
		load.getJson(url, param).done(function(json){
			//console.log(json)
			let HTML = "";
			for(var i = 0; i < 5; i++){
				let a = json.articles[i];
				let date = a.updated_at.origin;
				let d = new Date(date);
				let y = d.getFullYear();
				let m = d.getMonth() + 1;
				let day = d.getDate();
				HTML += '<li><a href=" https://prtimes.jp' + a.url + '" title="' + a.title + '" target="_blank"><p class="date">' + y + "." + m + "." + day + '</p><h5><span>' + a.title + '</span></h5></a></li>'
			}
			$("#pressrelease .content ul").html(HTML);
		});
	},
	podCast: function(){
		let podcastURL = "/top/xml/podcast.xml";
		let params = {};
		load.getXML(podcastURL, params).done(function(data){
			
			let podCastHTML = '';
			$(data).find("latest_item").each(function(i){
				let channelTitle 	= $(this).find("channel_title").text();
				let img 	= $(this).find("channel_image").text();
				let link	= $(this).find("channel_link").text(); 
				let title 	= $(this).find("item_title").text();
				let date = "";
				if( $(this).find("channel_date") ){
					date = $(this).find("channel_date").text();
				}
				podCastHTML += `<li>
									<div class="cat_podcast" id="rt_top_program_pc_3">
										<a href="${link}" title="EARLY GLORY">
											<div class="img"><figure style="background-image: url(${img})"></figure></div>
											<div class="txt">
												<div class="txt_inner">
													<div class="info">
														<p class="date">${date}</p>
														<p class="category">PODCAST</p>
													</div>
													<hgroup>
														<h4>${channelTitle}</h4>
														<div class="lead">
															<p>${title}</p>
														</div>
													</hgroup>
												</div>
											</div>
										</a>
									</div>
								</li>`;
				
				
				let $target = document.querySelector(`ul.list_foryou[data-list="program"]`);
				let $lists = $target.querySelectorAll("li");
				//console.log($lists);
				if( $lists.length >= 3 ){
					//すでにリストが3つあったら
					$lists[2].remove();
				}else{
					
				}
				$target.insertAdjacentHTML('beforeend', podCastHTML);
			});
			
			
		});
	},
	getXML: function(url, params){
		var defer 	= $.Deferred();
		var url 	= url;
		$.ajax({
			type: "GET",
			dataType: 'xml',
			url: url,
			data: params,
			success	: defer.resolve,
			error: defer.reject
		});
		return defer.promise();
	},
	getJson: function(url,params){
		var defer 	= $.Deferred();
		var url 	= url;
		$.ajax({
			type: "GET",
			dataType: 'json',
			url: url,
			data: params,
			success	: defer.resolve,
			error: defer.reject
		});
		return defer.promise();
	}
}
